<script setup>
import Mascot from '@images/mascot.png'
</script>

<template>
  <img :src="Mascot" alt="Convict Records" />
</template>
